<div class="excel_report {{class}}" [hidden]="util.isMobile()" *ngIf="isPaid || isSuperAdmin">
  <button
    *ngIf="filterStyle; else legacyButton"
    mhFilterTrigger
    class="tw-relative"
    [filterIconOnly]="!label"
    [filterOpen]="menuTrigger.menuOpen"
    [matMenuTriggerFor]="menu"
    #menuTrigger="matMenuTrigger"
    [disabled]="type==='empty' || disableReport"
    [attr.aria-label]="label ? null : ('header.tooltips.download_report' | translate)"
    [mhTooltip]="label ? '' : ('header.tooltips.download_report' | translate)"
    width="tw-w-fit"
    position="above"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>

  <ng-template #legacyButton>
    <button
      class="tw-text-[#0F93CC] tw-flex tw-justify-center tw-items-center tw-px-5 tw-py-3 tw-gap-2 focus:tw-outline-0 hover:tw-bg-blue-50 tw-transition-colors tw-h-10 tw-relative tw-min-w-[40px] tw-rounded-full"
      [class.tw-border]="showBorder"
      [class.tw-border-[#0F93CC]]="showBorder"
      [matMenuTriggerFor]="menu"
      [disabled]="type==='empty' || disableReport"
      [mhTooltip]="'header.tooltips.download_report' | translate"
      width="tw-w-fit"
      position="above"
    >
      <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </button>
  </ng-template>

  <ng-template #buttonContent>
    <div [class.show]="waiting" class="spinner_wait">
      <mh-spinner-classic></mh-spinner-classic>
    </div>
    <i
      class="fal fa-arrow-to-bottom"
      [class.tw-text-[#0F93CC]]="!filterStyle"
      [class.tw-text-neutral-500]="filterStyle"
      [hidden]="type==='empty'"
      [class.waiting]="waiting"
    ></i>
    <span
      *ngIf="label"
      class="tw-whitespace-nowrap"
      [class.tw-text-neutral-500]="filterStyle"
      [class.tw-hidden]="filterStyle"
      [class.md:tw-inline]="filterStyle"
    >
      {{ label | translate }}
    </span>
  </ng-template>

  <mat-menu #menu="matMenu">
    <button mat-menu-item  (click)="getReport()" *ngIf="!onlyEmail">
      <i class="fal fa-download"></i> {{'reports.downloads.excel.download_report' | translate}}
    </button>
    <button mat-menu-item (click)="getReport(true)" *ngIf="activeEmail">
      <i class="fal fa-envelope"></i> {{'reports.downloads.excel.send_report' | translate}}
    </button>
    <button mat-menu-item (click)="getReport(true, true)" *ngIf="type === 'chainOnlineSummary'">
      <i class="fal fa-envelope"></i> {{'reports.downloads.excel.review_online_report' | translate}}
    </button>
    <button mat-menu-item (click)="getReport(true, false, false, true)" *ngIf="type === 'chainFollowupSummary' || type === 'chainOnsiteFollowupSummary'">
      <i class="fal fa-envelope"></i> {{'reports.downloads.excel.guests_survey_report' | translate}}
    </button>
  </mat-menu>

</div>
